'POLineMaint'.maint({panelStyle: "titled", icon: 'PeopleArrows'})
'Add Purchase Order Line'.title({when: 'adding'})
'Edit Purchase Order Line'.title({when: 'editing'})
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Save'.action({act: 'save'})
'Add another line'.action({act: 'add'})
'POLine'.datatype()

'Line Details'.panel()
'purchaseOrder'.field({refersToParent: 'PO'})
'lineType'.field()
'product'.field({refersTo: 'products'})
'description'.field({allowEmpty: false, showAsLink: true})

'Retail Pricing'.panel()
'avgUnitCostIncludingThisOrder'.field({readOnly: true})
'recommendedRetailPriceIncTax'.field()
'wooCommerceRegularPrice'.field()
'marginPct'.field({readOnly: true})

'Quantity and Cost'.panel()
'quantityPU'.field()
'uom'.field({caption: 'Purchasing Unit of Measure', readOnly: true})
'quantity'.field({numeric: true})
'currency'.field({readOnly: true, showAsLink: true})
'unitCostExclTaxFX'.field({numeric: true})
'unitCostIncTaxFX'.field({numeric: true, caption: "Unit Price (Inc Tax)"})
'taxPct'.field({numeric: true, decimals: 2, caption: "Tax %"})
'lineCostIncTaxFX'.field({numeric: true, minDecimals: 2, maxDecimals: 6, caption: "Line Total (Inc Tax)", readOnly: true})
'lineTaxFX'.field({numeric: true, decimals: 2, readOnly: true})

'Product Image'.panel()
'image'.field({caption: ''})

'Received'.panel()
'receivedQuantity'.field({numeric: true, readOnly: true})
'cancelledQuantity'.field({numeric: true, readOnly: true})

'Lots'.manifest()
'Add Lot'.action({act: 'add'})
'Add Serial Number'.action({act: 'add'})
'Allotment'.datatype()
'lot'.field({showAsLink: true, caption: 'Number'})
'quantity'.field()
'expiryDate'.field()
'Edit'.action({place: 'row', act: 'edit'})
'Trash'.action({place: 'row', act: 'trash'})
'AllotmentMaint.js'.maintSpecname()

'Product Image'.visibleWhen((maint, line) => {
  return ((line.lineType === 'Product') && line.product) ? true : false
})

'quantityPU'.afterUserChange(async (oldInputValue, newInputValue, poLine) => {
  await poLine.maybeRefreshQuantity()
})

'quantityPU'.visibleWhen((maint, poLine) => {
  return poLine.purchasingUOMDiffers()
})

'uom'.visibleWhen((maint, poLine) => {
  if ( ! poLine.product ) return false
  let c = 'Configuration'.bringSingleFast(); if ( ! c ) return false
  return c.showUOMOnPOLines === 'Yes'
})

'Add Lot'.availableWhen(poLine => {
  return (poLine.hasLots === 'Yes') && (poLine.lotsAreSerials !== 'Yes')
})

'Add Serial Number'.availableWhen(poLine => {
  return (poLine.lotsAreSerials === 'Yes')
})

'Lots'.dynamicTitle(function() {
  let grid = this
  let poLine = grid.containerCast()
  if ( poLine.lotsAreSerials === 'Yes' )
    return 'Serial Numbers'
  else
    return 'Lots'
})

'Lots'.visibleWhen((maint, poLine) => {
  return poLine.hasLots === 'Yes'
})

'POLineMaint'.makeDestinationFor('POLine')

'POLine'.datatype()

'unitCostExclTaxFX'.visibleWhen((maint, poLine) => {
  return poLine.includeTaxOption === "No"
})

'unitCostIncTaxFX'.visibleWhen((maint, poLine) => {
  return poLine.includeTaxOption !== "No"
})

'Retail Pricing'.visibleWhen((maint, poLine) => {
  return (! poLine.lineType) || (poLine.lineType === 'Product')
})

'Received'.visibleWhen((maint, poLine) => {
  return (! poLine.lineType) || (poLine.lineType === 'Product')
})

'currency'.visibleWhen((maint, poLine) => {
  return poLine.currency ? true : false
})

'POLineMaint'.warning(async (maint, poLine) => {
  let avenue = await poLine.toAvenue(); if ( ! avenue ) return
  let min = avenue.minimumOrderQuantity; if ( ! min ) return
  if ( poLine.quantity >= min ) return
  return "Supplier minimum order quantity for this product is ".translate() + min
})

'product'.afterUserChange(async (oldInputValue, newInputValue, poLine, maint) => {
  let name = await poLine.toProductName()
  if ( name )
    maint.setFieldValue('description', name)
  let product = await 'products'.bringFirst({uniqueName: newInputValue}) 
  if ( product ) {
    maint.setFieldValue('wooCommerceRegularPrice', product._regular_price)
    let taxPct = await product.toTaxPct()
    maint.setFieldValue('taxPct', taxPct)
    let avenue = await poLine.toAvenue()
    if ( avenue ) {
      maint.setFieldValue('recommendedRetailPriceIncTax', avenue.recommendedRetailPriceIncTax)
    }
    let inv = await product.toInventory();
    if ( inv ) {
      let curr = await poLine.referee('currency')
      let costIncTax = await inv.getDefaultPurchaseUnitCostIncTax()
      let priceFXIncTax = await global.localAmountToForeign(costIncTax, curr)
      if ( priceFXIncTax )
        maint.setFieldValue('unitCostIncTaxFX', priceFXIncTax)
      let costExclTax = await inv.getDefaultPurchaseUnitCostExclTax()
      let priceFXExclTax = await global.localAmountToForeign(costExclTax, curr)
      if ( priceFXExclTax )
        maint.setFieldValue('unitCostExclTaxFX', global.roundTo2Decimals(priceFXExclTax))
    }
    let uomRef = inv ? inv.purchasingUOM : null
    if ( ! uomRef ) {
      let c = await 'Configuration'.bringFirst()
      uomRef = c ? c.defaultStockingUOM : null
    }
    poLine.uom = global.copyObj(uomRef)
  }
  await poLine.refreshUnspecifiedLot()
  await poLine.maybeRefreshQuantity()
})

'lineType'.afterUserChange(async (oldInputValue, newInputValue, poLine, maint) => {
  let lineType = poLine.lineType
  if ( lineType === "Other" ) {
    maint.setFieldValue('description', '')
    maint.setFieldValue('quantity', 1)
  } else if ( lineType && (lineType !== "Product") ) {
    maint.setFieldValue('description', lineType)
    maint.setFieldValue('quantity', 1)
  }
  await poLine.refreshUnspecifiedLot()
})

'product'.visibleWhen((maint, poLine) => {
  let lineType = poLine.lineType
  return (! lineType) || (lineType === "Product")
})

'receivedQuantity'.visibleWhen((maint, poLine) => {
  let lineType = poLine.lineType
  return (! lineType) || (lineType === "Product")
})

'cancelledQuantity'.visibleWhen((maint, poLine) => {
  let lineType = poLine.lineType
  return (! lineType) || (lineType === "Product")
})

'taxPct'.inception(async (poLine) => {
  let config = await 'Configuration'.bringSingle(); if ( ! config ) return 0
  return config.taxPct
})

'POLine'.datatype()

'quantity'.afterUserChange(async (oldInputValue, newInputValue, poLine, maint) => {
  if ( poLine.hasLots === 'Yes' ) {
    let config = await 'Configuration'.bringSingle(); if ( ! config ) return
    await config.balanceAllotments(poLine)
  }
  await poLine.maybeRefreshQuantity()
})

'quantity'.readOnlyWhen((maint, poLine) => {
  return poLine.purchasingUOMDiffers()
})

